/**
 * Centralized product data for the Dalcomm Tech product line carried by
 * ctrl.aero.  Used by the four dedicated product pages, the GSE Adapters
 * & Accessories hub, and the dynamic per-accessory sub-product pages.
 *
 * Images and copy are sourced from dalcommtech.com's public product
 * catalog (Dalcomm Tech is the manufacturer / brand for these SKUs).
 */

// --------------------------- Headline products ---------------------------
// These four SKUs get dedicated fully-featured product pages.

export const DALCOMM_INTERCOM_KIT_IMAGES = [
  'https://dalcommtech.com/wp-content/uploads/2026/03/Three-person-wireless-kit-Dalcomm.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/3-Man-Wireless-Pushback-Kit.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/Four-person-wireless-kit-Dalcomm.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/4-Man-Wireless-Pushback-Kit-1.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/20260106_135910-scaled.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/Driver-Headset-Battery-level-indicator-lights.png',
  'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-44-e1773173159627.webp',
  'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-63.webp',
];

export const DALCOMM_EMBRY_RIDDLE_IMAGES = [
  'https://dalcommtech.com/wp-content/uploads/2025/11/ERAU-Ad-pic-scaled-1.png',
  'https://dalcommtech.com/wp-content/uploads/2025/11/Untitled-design-2-scaled-1.png',
  'https://dalcommtech.com/wp-content/uploads/2025/11/Untitled-design-8.png',
  'https://dalcommtech.com/wp-content/uploads/2025/11/MiniXLRe-r-1-scaled-1.jpg',
  'https://dalcommtech.com/wp-content/uploads/2025/11/ERAU-front-view.png',
];

export const DALCOMM_J1_IMAGES = [
  'https://dalcommtech.com/wp-content/uploads/2025/11/cropped-J3-3-3.jpg',
  'https://dalcommtech.com/wp-content/uploads/J3-3-3-300x300.jpg',
  'https://dalcommtech.com/wp-content/uploads/Headset5_1-240x300.jpg',
  'https://dalcommtech.com/wp-content/uploads/J1-ANR-GA_4-1-300x200.jpg',
  'https://dalcommtech.com/wp-content/uploads/J1-ANR-BT-GA_1-300x200.jpg',
];

export const DALCOMM_VINTAGE_IMAGES = [
  'https://dalcommtech.com/wp-content/uploads/2025/11/cropped-J7-corded-2.jpg',
  'https://dalcommtech.com/wp-content/uploads/cropped-J7-corded-2-300x282.jpg',
  'https://dalcommtech.com/wp-content/uploads/J8_10-1-300x200.jpg',
  'https://dalcommtech.com/wp-content/uploads/J7-ANR-GA-1-240x300.jpg',
  'https://dalcommtech.com/wp-content/uploads/J7H-Dual_3-300x200.jpg',
];

// ------------- GSE Adapters & Accessories (dynamic sub-products) -------------
// Every entry gets its own /products/dalcomm/gse-adapters/<slug> page.
// The Wireless Intercom Kit is intentionally excluded here (already surfaced
// as a headline product at /products/dalcomm/wireless-intercom-kit).

export const dalcommGseAccessories = [
  {
    slug: 'wireless-pushback-driver-headset',
    name: 'Wireless Pushback Driver Headset',
    price: '$1,260',
    tagline:
      'Turn it on, use it — that’s it. Wireless pushback driver headset with 550 ft range.',
    description:
      'Dalcomm Tech’s wireless version of our pushback driver headset is as easy to use as the wired version. Turn the headset on with the on/off/volume knob just like old TVs used to use. That’s literally all there is. Now it’s connected to the work group. This headset lets the pushback driver talk to the flight deck through the wireless gateway and to other wing walkers and supervisors in the work group.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/wireless-wing-walker-headset-front-view-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/wireless-wing-walker-headset-front-view.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-kit-highlighting-driver-headset-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-59.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Copy-of-Onoffvolume-knob.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/talk-through-view-wireless-wing-walker-headset.webp',
    ],
    features: [
      '915 MHz license-free medical/industrial/scientific band',
      '550 ft range headset-to-headset and headset-to-gateway',
      'On/off/volume single-knob control — no menus, no pairing',
      'Real-time 4-LED battery indicator (green/green/yellow/red)',
      'Internal antenna — fewer parts to break',
      'Interchangeable colored group-ID rings — 343 possible work groups',
    ],
  },
  {
    slug: 'wireless-wing-walker-headset',
    name: 'Wireless Wing Walker Headset',
    price: '$1,160',
    tagline:
      'Wireless wing walker headset — talk to the pushback driver and flight deck hands-free.',
    description:
      'Dalcomm Tech’s wireless wing walker headset is as easy to use as the wired version. Turn the headset on with the on/off/volume knob and you are instantly connected to the work group. The wing walker can talk to the pushback driver, supervisors, and the flight deck through the wireless gateway.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-Headset-Front-View-300x300.png',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-Headset-Front-View-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-kit-highlighting-wing-walker-headset-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Onoffvolume-knob.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-wing-walker-headset-mic-side-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/wireless-wing-walker-headset-front-view.webp',
    ],
    features: [
      '915 MHz license-free band, 550 ft range',
      'Single-knob on/off/volume — one motion to power on',
      'Real-time battery LEDs visible without removing the headset',
      'Broad frequency-response earphones and mic for clear comms',
      'Internal antenna, ruggedized housing',
      'Colored group-ID band for at-a-glance work-group identification',
    ],
  },
  {
    slug: 'wireless-pushback-gateway',
    name: 'Wireless Pushback Gateway',
    price: '$899',
    tagline:
      'Plugs into the belly of the aircraft — bridges the interphone into the wireless work group.',
    description:
      'The wireless gateway plugs into the aircraft external intercom jack and bridges the flight-deck interphone into the Dalcomm wireless work group. All headsets can hear the flight deck at all times, and the pushback driver can transmit back to the flight deck. Ships with an interchangeable aircraft-side cable so a single gateway serves multiple fleets.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-44-e1773173159627-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-44-e1773173159627.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Wireless-kit-highlighting-GATEWAY-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Gateway-top-view.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Gateway-TRS-Adapter.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/20260106_135910-scaled.webp',
    ],
    features: [
      'Interchangeable aircraft cable — 1/4", twin GA, U-174/U helicopter (civ/mil)',
      '915 MHz bridge to the Dalcomm wireless work group',
      'Belly-hang design with tether-safe housing',
      'Battery indicator lights on the top face',
      'Ruggedized enclosure for outdoor / all-weather ramp use',
    ],
  },
  {
    slug: 'ground-crew-headset-hardwired',
    name: 'Ground Crew Headset With Hardwired Cable',
    price: '$429 – $455',
    tagline:
      'GS-Series hardwired ground crew headset for pushback, ramp, and maintenance.',
    description:
      'Dalcomm ground crew headsets set a new standard in communications headsets. The hardwired variant is built for pushback, ramp, and maintenance crews who prefer a fixed cable and a lower per-seat cost than the wireless kit. Compatible with the full SGS adapter line for training, regional-jet Y-splits, and extension.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-GC-W-INLINE-PTT-COVER-1500-x-1500-px-1-300x300.png',
    features: [
      'GS-Series driver / wing walker form factor',
      'Hardwired cable with 1/4" ground-crew plug',
      'Noise-cancelling amplified dynamic mic',
      'Compatible with SGS-1, SGS-2, SGS-8, SGX extensions',
      'Configurable colorways for airline / airport standards',
    ],
  },
  {
    slug: 'gs2-with-microphone-shield',
    name: 'GS2 with Microphone Shield',
    price: '$395',
    tagline:
      'Two-ear ground crew headset with noise-blocking mic shield and inline PTT.',
    description:
      'Headset for very loud airport ground crew operations. The mic shield mechanically blocks wind and turbine wash while the noise-cancelling mic cleans the transmitted audio. Designed for ground support equipment (GSE) operators and aviation professionals in pushback, ramp operations, and maintenance.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/Two-Ear-Headset-with-Mouthguard-2-scaled-1-300x300.png',
    features: [
      'Two-ear over-the-head form factor',
      'Noise-blocking microphone shield',
      'Momentary push-to-talk on the cable',
      'Standard 1/4" ground-crew plug',
      'Rated for high-noise ramp / pushback / maintenance work',
    ],
  },
  {
    slug: 'ramp-headset-ptt',
    name: 'Ramp Headset with PTT',
    price: '$315 – $395',
    tagline:
      'GS-Series ramp headset with on-ear PTT — pushback and ramp communications.',
    description:
      'Dalcomm ramp headset with an on-ear push-to-talk button. Full-flex boom for microphone placement, noise-cancelling amplified dynamic mic, hands-free mic on/off switch on the ear cup, gel-saturated foam ear seal, and the choice of 15-foot straight or 30-foot coil cord. Available in orange, black, and blue.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-RAMP-HEADSET-w-ON-EAR-PTT-COVER1-1500-x-1500-px-300x300.png',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-RAMP-HEADSET-w-ON-EAR-PTT-COVER1-1500-x-1500-px-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-RAMP-HEADSET-w-ON-EAR-PTT-BLUE-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-RAMP-HEADSET-w-ON-EAR-PTT-BLACK-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/GS-SERIES-RAMP-HEADSET-w-ON-EAR-PTT-ORANGE-300x300.png',
    ],
    features: [
      'On-ear momentary PTT for pushback / ramp work',
      'Full-flex boom, right- or left-hand adjustable',
      'Noise-cancelling amplified dynamic mic',
      '15 ft straight OR 30 ft coil cord option',
      'Gel-saturated foam ear seals + soft foam headband pad',
      'Colorways: orange, black, blue',
    ],
  },
  {
    slug: 'ramp-headset-ptt-wire-boom',
    name: 'Ramp Headset with PTT (Wire Boom)',
    price: '$315 – $395',
    tagline:
      'Wire-boom ramp headset with PTT — lighter boom, same tough GS-Series body.',
    description:
      'Wire-boom variant of the Dalcomm ramp headset with PTT. Same GS-Series body, ear seals, and cord options as the flex-boom version — swapped to a thinner wire boom for crews who want a lower-profile microphone arm. Colorways: orange, black, and blue.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/H3392-H3332-Orange-300x300.png',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2025/11/H3392-H3332-Orange-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/H3392-H3332-Black-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/H3392-H3332-Blue-300x300.png',
    ],
    features: [
      'Wire boom — low-profile alternative to the flex boom',
      'On-ear PTT for pushback / ramp work',
      'Noise-cancelling amplified dynamic mic',
      '15 ft straight OR 30 ft coil cord option',
      'Standard 1/4" ground-crew plug',
      'Colorways: orange, black, blue',
    ],
  },
  {
    slug: 'sgs-push-to-talk-cable',
    name: 'SGS Series Push-to-Talk Cable',
    price: '$96 – $380',
    tagline:
      'Bright-orange PTT cables for airline/airport pushback and ramp comms.',
    description:
      'SGS Series push-to-talk cables in bright safety orange. All variants have a 1/4" jack to mate with standard ground-crew headsets and a cord tether hook for attaching the cable to aircraft or apparatus. Custom cables available on request.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/SGS-Push-to-Talk-scaled-1-300x300.png',
    features: [
      '1/4" jack — mates with all standard ground-crew headsets',
      'Cord tether hook for airplane / GSE attachment',
      'Safety-orange jacket for visibility on the ramp',
      'Multiple lengths available',
      'Custom variants available on request',
    ],
  },
  {
    slug: 'battery-backup-wireless-headsets',
    name: 'Battery Backup for Wireless Headsets',
    price: '$375',
    tagline:
      'Belt-clip battery backup — plug it into any Dalcomm wireless headset for instant runtime.',
    description:
      'Plug this battery backup into a Dalcomm wireless headset charging port to get up and running again instantly. It has a similar look to the wireless gateway but is much smaller. Use the belt clip to clip it to a belt, vest, or jacket. Ruggedized for airport use, waterproof, with battery indicator lights and a locking charging port.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-67-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-67-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Untitled-design-66-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Battery-Backup-On-State-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Charge-Level-Indicator-1-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Charging-port-%E2%9F%B6-1-300x300.webp',
    ],
    features: [
      'Belt-clip form factor for at-work top-ups',
      'Ruggedized, waterproof housing',
      '4-LED battery-level indicator',
      'Locking charging port',
      'Fits all Dalcomm wireless headset charging ports',
    ],
  },
  {
    slug: 'sgx-extension-cables',
    name: 'SGX Series Extension Cables',
    price: '$87 – $324',
    tagline:
      'Bright-orange extension cables for pushback and ramp — 1/4" TRS or twin GA plugs.',
    description:
      'SGS Series extension cables in bright safety orange. Available with a 1/4" TRS plug or twin GA plugs. All variants have a 1/4" jack to mate with standard ground-crew headsets, plus a cord tether hook for aircraft / apparatus attachment. Custom variants available.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/SGS-Series-Extension-Cable-Cover-scaled-1-300x300.png',
    features: [
      '1/4" TRS plug OR twin GA plugs',
      '1/4" jack — pairs with any standard ground-crew headset',
      'Cord tether hook',
      'Bright safety-orange jacket',
      'Multiple lengths / custom lengths on request',
    ],
  },
  {
    slug: 'interphone-cable-wireless-gateway',
    name: 'Airplane Interphone Cable for Wireless Gateway',
    price: '$89 – $135',
    tagline:
      'Plug the Dalcomm wireless gateway into any aircraft interphone — 1/4", twin GA, or U-174/U.',
    description:
      'This cable plugs into the Dalcomm wireless gateway and connects it to the aircraft interphone system. The 1/4" version also adapts the gateway to most intercom systems that require a 1/4" plug. Choose the variant that matches your fleet.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Gateway-TRS-Adapter-300x300.webp',
    features: [
      '1/4" plug variant for widebody / most intercom systems',
      'Twin GA plug variant for GA-style intercoms',
      'U-174/U helicopter plug variants (civilian + military pinout)',
      'Interchangeable at the gateway — swap between fleets in seconds',
    ],
  },
  {
    slug: 'sgs-8-adapter',
    name: 'SGS-8 GA Twin Plugs to Single 1/4" Ground-Crew Plug',
    price: '$110',
    tagline:
      'Convert twin GA plugs into a single 1/4" ground-crew plug.',
    description:
      'SGS-8 adapter cable converts twin GA plugs into a single ground-crew 1/4" plug. Cable has a 1/4" jack (for PJ-068 or 1/4" earphone plug) and a 0.206" jack (for PJ-051 mic plug), terminating in a 1/4" ground-support plug.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/Training-Adapter-wm-300x300.png',
    features: [
      'GA twin plugs → single 1/4" ground-crew plug',
      '1/4" and 0.206" jacks accept PJ-068 / PJ-051 aviation plugs',
      'Rated for training, ramp, and maintenance use',
      'Standard-length cable, custom on request',
    ],
  },
  {
    slug: 'sgs-1-training-adapter',
    name: 'SGS-1 Training Adapter — 2× 1/4" Jacks, 1× 1/4" Plug',
    price: '$110',
    tagline:
      'Two headsets on one ground-support port — pushback and aircraft-movement training.',
    description:
      'SGS-1 adapter cable connects two headsets during pushback or aircraft-movement training. Cable has a 1/4" ground-support plug and two 1/4" jacks so two headsets can be plugged in simultaneously. Designed for use with GS1 and GS2 headsets.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/Training-Adapter-wm-300x300.png',
    features: [
      '1× 1/4" ground-support plug + 2× 1/4" jacks',
      'Trainer + trainee simultaneous connection',
      'Designed for GS1 / GS2 headsets',
      'Standard-length cable, custom on request',
    ],
  },
  {
    slug: 'sgs-2-regional-jet-adapter',
    name: 'SGS-2 Regional Jet Y-Adapter',
    price: '$110',
    tagline:
      'Y-adapter for regional-jet intercoms equipped with two jacks.',
    description:
      'SGS-2 adapter designed for regional-jet aircraft intercoms equipped with two jacks. Features dual plugs and a 1/4" ground-support jack. Designed for use with GS1 and GS2 headsets.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/regional-jet-adapter-wm-300x300.png',
    features: [
      'Dual plugs for regional-jet two-jack intercoms',
      '1/4" ground-support jack',
      'Compatible with GS1 / GS2 headsets',
      'Compact, ramp-durable build',
    ],
  },
  {
    slug: 'wireless-intercom-charging-cable',
    name: 'Wireless Intercom Charging Cable',
    price: '$78 – $95',
    tagline:
      'USB-A ↔ mini XLR charging cable for Dalcomm wireless headsets and gateway.',
    description:
      'Use this cable to charge Dalcomm wireless headsets and accessories. USB-A on one end and a mini XLR female plug on the other. Plug the USB end into a charging source (the wireless kit case, a laptop, a wall charger) and the mini XLR end into any Dalcomm wireless-series device. Available in straight, coiled, and 10-ft variants.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Charging-cable-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/Charging-cable-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/Your-paragraph-text-1-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/coiled-charging-cable-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/10-ft-charging-cable-300x300.webp',
    ],
    features: [
      'USB-A → mini XLR female',
      'Works with headsets, gateway, and battery backup',
      'Straight, coiled, and 10-ft length options',
      'Charging-kit-compatible connector shape',
    ],
  },
  {
    slug: 'remove-before-flight-streamer',
    name: 'Remove Before Flight Streamer',
    price: '$9',
    tagline:
      'Safety streamer for the wireless gateway — keep it on the gateway at all times.',
    description:
      'Remove Before Flight streamer for the Dalcomm wireless gateway. Keep this safety streamer on the gateway at all times. Replace damaged streamers immediately to preserve the safety cue for pushback and pre-departure walkarounds.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/Remove-Before-Flight-Streamer-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/Remove-Before-Flight-Streamer-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/streamer-on-gateway-on-plane-300x300.webp',
    ],
    features: [
      'Standard red RBF streamer',
      'Sized and mounted for the Dalcomm wireless gateway',
      'Consumable — replace on damage',
    ],
  },
  {
    slug: 'tether-hook',
    name: 'Tether With Hook for Ground-Crew Comm Cables',
    price: '$6',
    tagline:
      'Hook + tether for attaching ground-crew cables to widebody and regional aircraft.',
    description:
      'Hook with tether for attaching ground-crew headset cables to airplanes — widebody and regional-jet aircraft. Adds an anchor point so the cable does not swing free during pushback.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2025/11/Tether-Hook-2-300x300.png',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2025/11/Tether-Hook-2-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2025/11/Tether-Hook-300x300.png',
    ],
    features: [
      'Hook + tether combination',
      'Widebody and regional-jet compatible',
      'Prevents cable swing during pushback',
      'Rated for daily ramp use',
    ],
  },
  {
    slug: 'power-cord-wireless-kit-case',
    name: 'Power Cord for Wireless Kit Case',
    price: 'Contact for pricing',
    tagline:
      '10 ft single-outlet extension cord for the wireless kit case — indoor use.',
    description:
      'Use this cord to plug the wireless kit case into a regular wall outlet. Single-outlet extension cord with a plug at one end and a single receptacle at the other end. Lightweight jacket — indoor use only, not rated for wide outdoor temperature ranges.',
    image:
      'https://dalcommtech.com/wp-content/uploads/2026/03/10-ft-extension-cord-300x300.webp',
    images: [
      'https://dalcommtech.com/wp-content/uploads/2026/03/10-ft-extension-cord-300x300.webp',
      'https://dalcommtech.com/wp-content/uploads/2026/03/open-charging-port-300x300.png',
      'https://dalcommtech.com/wp-content/uploads/2026/03/charging-port-300x300.webp',
    ],
    features: [
      '10 ft length, 5-15P plug, 16/3 gauge',
      'Single-outlet receptacle',
      'Indoor use only',
      'Ships pre-configured for the wireless kit case',
    ],
  },
];

export const dalcommAccessoryBySlug = (slug) =>
  dalcommGseAccessories.find((p) => p.slug === slug);
